import React from "react";
import {Layout, notification, Typography} from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import compose from 'recompose/compose';
import { ReducerType } from "../../redux/reducer.type";
import { LayoutAppPropsType } from "./layout-app.type";
import MenuLeft from "../../components/layout/MenuLeft";
import TopBar from "../../components/layout/TopBar";
import {isSuperAdmin, validateSessionStorage} from "../../utils/utils";
import {withTranslation} from "react-i18next";
import style from "../../components/layout/TopBar/style.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faExclamation, faMobile} from "@fortawesome/free-solid-svg-icons";
import Regulation from "./Regulation";
import {acceptRegulationApi,getWorkspaceDetailsApi} from "../../services/workspace.service";
let regulation_modal = 0;
class AppLayout extends React.Component<LayoutAppPropsType, any> {
    state = {
        reload: false,
        loading: false
    };

    acceptRegulations = (uuid:string) => {
        const { t } = this.props;
        this.setState({loading:true});
       acceptRegulationApi(uuid).then(() => {
           getWorkspaceDetailsApi(uuid).then((res) => {
               if(res.data && res.data.regulations_accepted) {
                   notification.success({
                       message:t("accept_success"),
                       description: t("accept_success_description")
                   });
                   regulation_modal = 2;
               } else {
                   notification.error({
                       message: t("error_accept"),
                       description: t("error_accept_description")
                   });
                   regulation_modal = 1;
               }
               this.setState({loading:false})
           })

       }).catch(() => {
           notification.error({
               message: t("error_accept"),
               description: t("error_accept_description")
           });
           regulation_modal = 1;
           this.setState({loading:false})
       })
    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const {
            children,
            settings: {
                isContentNoMaxWidth,
                isAppMaxWidth,
                isGrayBackground,
                isSquaredBorders,
                isCardShadow,
                isBorderless,
                isTopbarFixed,
                isGrayTopbar,
                menuLayoutType,
            },
            user,
            t
        } = this.props;
        const { Text } = Typography;

        if(regulation_modal === 0) {
            let owner_uuid = user && user.activeWorkspace && user.activeWorkspace.owner && user.activeWorkspace.owner.uuid;
            let user_uuid = user && user.uuid;
            if(owner_uuid === user_uuid) {
                if(user && user.activeWorkspace &&  user.activeWorkspace.customer_type === "S" && (user.activeWorkspace.regulations_accepted === false || user.activeWorkspace.regulations_accepted === null) ) regulation_modal = 1;
            }
        }
        if(isSuperAdmin()) regulation_modal = 2;
        return (
            <>
                { regulation_modal === 1 &&
                    <div className={classNames({
                        air__layout__regulations_box: regulation_modal
                    })}>
                        <Regulation
                            // @ts-ignore
                            regulation_modal={regulation_modal}
                            acceptRegulations={this.acceptRegulations}
                        />
                    </div>
                }
                <Layout
                    className={classNames({
                        air__layout__contentNoMaxWidth: isContentNoMaxWidth,
                        air__layout__appMaxWidth: isAppMaxWidth,
                        air__layout__grayBackground: isGrayBackground,
                        air__layout__squaredBorders: isSquaredBorders,
                        air__layout__cardsShadow: isCardShadow,
                        air__layout__borderless: isBorderless,
                        air__layout__regulations: regulation_modal === 1
                    })}
                >
                    {
                        validateSessionStorage("access_token") &&
                        menuLayoutType === 'left' && <MenuLeft />
                    }
                    <Layout>
                        {
                            validateSessionStorage("access_token") &&
                            <Layout.Header
                                className={classNames('air__layout__header', {
                                    air__layout__fixedHeader: isTopbarFixed,
                                    air__layout__headerGray: isGrayTopbar,
                                })}
                            >
                                {user && user.activeWorkspace && Number(user.activeWorkspace.is_blocked) === 2 && (user.activeWorkspace.owner?.uuid === user.uuid) && <div className={style.error_block}>
                                        <div>
                                            <FontAwesomeIcon icon={faExclamation} color={"red"} style={{fontSize:"18px", marginRight:"15px"}}/>
                                        </div>
                                        <div className={style.info}>
                                            <Text>{t("workspace_payment_error_1")} <strong>{t("workspace_payment_error_2")}</strong>, {t("workspace_payment_error_3")} <strong>{t("workspace_payment_error_4")}.</strong></Text>
                                            <Text>{t("workspace_payment_error_5")}.</Text>
                                            {/*<Text>{t("workspace_payment_error_6")} <strong>{t("workspace_payment_error_7")}.</strong></Text>*/}
                                            <Text>{t("workspace_payment_error_8")}.</Text>
                                            <Text className={style.contact}>
                                                <Text><FontAwesomeIcon style={{width:20}} icon={faEnvelope}/> biuro@insmobile.pl</Text>
                                                <Text><FontAwesomeIcon style={{width:20}} icon={faMobile}/> +48 507 178 450</Text>
                                            </Text>
                                        </div>
                                    </div>
                                }
                                <TopBar />
                            </Layout.Header>
                        }
                        <Layout.Content style={{ height: '100%', position: 'relative' }}>
                            <div className="air__utils__content">{children}</div>
                        </Layout.Content>
                        {/*<Layout.Footer>*/}
                        {/*    /!*<Footer />*!/*/}
                        {/*</Layout.Footer>*/}
                    </Layout>
                </Layout>
            </>

        );
    }
}

const mapStateToProps = (state: ReducerType) => ({settings: state.settings,user: state.user,isMobile: state.settings.isMobileView,});

export default withRouter(compose<LayoutAppPropsType, any>(
    connect(mapStateToProps),
    withTranslation("workspaces")
)(AppLayout)) as React.ComponentClass<{}>;
